import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const initInspectionFilterValues = {
  name: '',
  status: '',
  placeId: null,
  inspectionSubjectId: null,
  dueDateFrom: null,
  dueDateTo: null,
  doneAtFrom: null,
  doneAtTo: null,
  canceledAtFrom: null,
  canceledAtTo: null,
  inspectorId: null,
};

export const initInspectionSubjectFilterValues = {
  name: '',
  serialNumber: '',
};

export const initPlaceFilterValues = {
  name: '',
};

export const initUserFilterValues = {
  name: '',
  email: '',
};

export const initTemplateFilterValues = {
  name: '',
};

export const initPlaceSpaceUserFilterValues = {
  name: '',
  email: '',
  role: '',
};

export const FilterProvider = ({ children }) => {
  const [inspectionsFilter, setInspectionsFilter] = useState(initInspectionFilterValues);
  const [inspectionSubjectsFilter, setInspectionSubjectsFilter] = useState(
    initInspectionSubjectFilterValues
  );
  const [placesFilter, setPlacesFilter] = useState(initPlaceFilterValues);
  const [templatesFilter, setTemplatesFilter] = useState(initTemplateFilterValues);
  const [placeSpaceUsersFilter, setPlaceSpaceUsersFilter] = useState(
    initPlaceSpaceUserFilterValues
  );
  const [usersFilter, setUsersFilter] = useState(initUserFilterValues);

  return (
    <FilterContext.Provider
      value={{
        inspectionsFilter,
        setInspectionsFilter,
        inspectionSubjectsFilter,
        setInspectionSubjectsFilter,
        placesFilter,
        setPlacesFilter,
        templatesFilter,
        setTemplatesFilter,
        usersFilter,
        setUsersFilter,
        placeSpaceUsersFilter,
        setPlaceSpaceUsersFilter,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => useContext(FilterContext);
